import { render, staticRenderFns } from "./PageNoPermission.vue?vue&type=template&id=3d8fcc44&scoped=true"
import script from "./PageNoPermission.vue?vue&type=script&lang=js"
export * from "./PageNoPermission.vue?vue&type=script&lang=js"
import style0 from "./PageNoPermission.vue?vue&type=style&index=0&id=3d8fcc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8fcc44",
  null
  
)

export default component.exports